import { apiClient } from './requestInterceptor';

interface MetricData {
    value: number;
    change: number;
    sparkline: number[];
}

interface TimeSeriesData {
    timestamp: string;
    [key: string]: string | number;
}

export async function fetchUniqueInteractions(userKey: string, projectKey: string, timeRange: string): Promise<MetricData> {
    const response = await apiClient(`/metrics/unique-interactions?projectKey=${projectKey}&timeRange=${timeRange}`, userKey);
    if (!response.ok) throw new Error('Failed To Retrieve Data');
    return response.json();
}

export async function fetchAgentHandoffs(userKey: string, projectKey: string, timeRange: string): Promise<MetricData> {
    const response = await apiClient(`/metrics/agent-handoffs?projectKey=${projectKey}&timeRange=${timeRange}`, userKey);
    if (!response.ok) throw new Error('Failed To Retrieve Data');
    return response.json();
}

export async function fetchToolCalls(userKey: string, projectKey: string, timeRange: string): Promise<MetricData> {
    const response = await apiClient(`/metrics/tool-calls?projectKey=${projectKey}&timeRange=${timeRange}`, userKey);
    if (!response.ok) throw new Error('Failed To Retrieve Data');
    return response.json();
}

export async function fetchErrors(userKey: string, projectKey: string, timeRange: string): Promise<MetricData> {
    const response = await apiClient(`/metrics/errors?projectKey=${projectKey}&timeRange=${timeRange}`, userKey);
    const data = await response.json();
    if (!response.ok) throw new Error('Failed To Retrieve Data');
    return data;
}

export async function fetchUniqueInteractionsOverTime(userKey: string, projectKey: string, timeRange: string): Promise<TimeSeriesData[]> {
    const response = await apiClient(`/metrics/unique-interactions-over-time?projectKey=${projectKey}&timeRange=${timeRange}`, userKey);
    if (!response.ok) throw new Error('Failed To Retrieve Data');
    return response.json();
}

export interface InsightData {
    topAgent: { name: string; count: number };
    mostErrored: { tool: string; agent: string; count: number };
    commonError: string;
}

export async function fetchInsights(userKey: string, projectKey: string, timeRange: string): Promise<InsightData> {
    const response = await apiClient(`/metrics/insights?projectKey=${projectKey}&timeRange=${timeRange}`, userKey);
    if (!response.ok) throw new Error('Failed To Retrieve Data');
    return response.json();
}

export async function fetchToolCallsOverTime(userKey: string, projectKey: string, timeRange: string): Promise<TimeSeriesData[]> {
    const response = await apiClient(`/metrics/tool-calls-over-time?projectKey=${projectKey}&timeRange=${timeRange}`, userKey);
    if (!response.ok) throw new Error('Failed To Retrieve Data');
    return response.json();
}
